import { render, staticRenderFns } from "./FormDataselection.vue?vue&type=template&id=4bc4a7a1&"
import script from "./FormDataselection.vue?vue&type=script&lang=js&"
export * from "./FormDataselection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports